import React from 'react';
import { UserPlus, Search, FileText, Send } from 'lucide-react';
import './HowItWorks.css';

const steps = [
  {
    number: "01",
    icon: UserPlus,
    title: "Inscription",
    description: "L'électeur remplit un formulaire simple : ses coordonnées, son bureau de vote, et s'il est mandant ou mandataire."
  },
  {
    number: "02",
    icon: Search,
    title: "Matching",
    description: "L'algorithme ProcuMatcher analyse les disponibilités et la proximité géographique pour trouver le binôme idéal."
  },
  {
    number: "03",
    icon: FileText,
    title: "CERFA généré",
    description: "Le formulaire CERFA 14952*03 est automatiquement pré-rempli avec les informations des deux parties."
  },
  {
    number: "04",
    icon: Send,
    title: "Notification",
    description: "Mandant et mandataire reçoivent un email avec le CERFA et les instructions pour finaliser la procuration."
  }
];

function HowItWorks() {
  return (
    <section id="how-it-works" className="how-it-works">
      <div className="how-it-works__container container">
        <div className="how-it-works__header">
          <span className="how-it-works__label">Comment ça marche</span>
          <h2 className="how-it-works__title">
            4 étapes simples pour gérer vos procurations
          </h2>
        </div>
        
        <div className="steps">
          {steps.map((step, index) => (
            <div key={index} className="step">
              <div className="step__number">{step.number}</div>
              <div className="step__icon">
                <step.icon size={32} />
              </div>
              <div className="step__content">
                <h3 className="step__title">{step.title}</h3>
                <p className="step__description">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="step__connector" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;

